import Cookies from 'js-cookie';

export function tokenExpiresAt(token: string): number | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const expiry = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '='))).exp;
    return typeof expiry === 'number' && Number.isFinite(expiry) && expiry > 0 ? expiry * 1000 : null;
  } catch (_) { return null; }
}

export function safeReturnUrl(value: string | null): string | null {
  try {
    if (!value || !value.startsWith('/') || value.startsWith('//')) return null;
    const target = new URL(value, window.location.origin);
    if (target.origin !== window.location.origin || !['/Sync', '/code', '/code/'].includes(target.pathname)) return null;
    return target.pathname + target.search + target.hash;
  } catch (_) { return null; }
}

export function clearAuthSession(): void {
  sessionStorage.removeItem('jwt_token');
  localStorage.setItem('auth_signed_out', '1');
  const options = { path: '/' };
  Cookies.remove('jwt_token', options);
  if (window.location.hostname.endsWith('.itri-nlp.tw')) {
    Cookies.remove('jwt_token', { ...options, domain: '.itri-nlp.tw' });
  }
}

export function saveAuthToken(token: string): boolean {
  const expiry = tokenExpiresAt(token);
  if (expiry === null || expiry <= Date.now() || localStorage.getItem('auth_signed_out') === '1') return false;
  sessionStorage.setItem('jwt_token', token);
  const options = { expires: new Date(expiry), path: '/', secure: window.location.protocol === 'https:', sameSite: 'Lax' as const };
  Cookies.set('jwt_token', token, options);
  if (window.location.hostname.endsWith('.itri-nlp.tw')) {
    Cookies.set('jwt_token', token, { ...options, domain: '.itri-nlp.tw' });
  }
  return true;
}

export function startAuthSession(token: string): boolean {
  const expiry = tokenExpiresAt(token);
  if (expiry === null || expiry <= Date.now()) return false;
  localStorage.removeItem('auth_signed_out');
  return saveAuthToken(token);
}

export function readAuthToken(): string | null {
  if (localStorage.getItem('auth_signed_out') === '1') return null;
  const candidates = [Cookies.get('jwt_token'), sessionStorage.getItem('jwt_token')];
  for (const token of candidates) {
    if (token && saveAuthToken(token)) return token;
  }
  return null;
}
